import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import Badge from '../components/Badge';
import { MapPinIcon, CalendarIcon, NavTicketIcon, WaveIcon } from '../components/Icons';

function fmt(d) {
  if (!d) return '–';
  return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function ArchiveList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get('/api/events').then((r) => setEvents(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <h1 className="page-title">Archiv</h1>
      <p className="text-sm text-slate-500 -mt-3 mb-6">Vergangene BeachLAN-Events mit Turnieren und Ergebnissen.</p>
      {loading && (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-ocean-400 border-t-transparent"/>
        </div>
      )}
      {!loading && events.length === 0 && (
        <div className="card text-center py-12">
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-ocean-400 to-ocean-700 flex items-center justify-center shadow-sm">
              <WaveIcon className="w-6 h-6 text-white" />
            </div>
          </div>
          <p className="text-slate-500">Noch keine vergangenen Events im Archiv.</p>
        </div>
      )}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {events.map((e) => (
          <div key={e.id} className="card hover:shadow-card-hover transition-shadow duration-200 flex flex-col">
            <div className="flex justify-between items-start mb-3">
              <h3 className="font-bold text-ocean-900 text-base leading-tight">{e.name}</h3>
              <Badge status={e.status} />
            </div>
            {e.location && (
              <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(e.location)}`}
                target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-ocean-600 mb-1 no-underline">
                <MapPinIcon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
                {e.location}
              </a>
            )}
            <p className="flex items-center gap-1.5 text-sm text-slate-500 mb-0.5">
              <CalendarIcon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
              <span><span className="text-slate-400 text-xs mr-1">Start</span>{fmt(e.start_date)}</span>
            </p>
            {e.end_date && (
              <p className="flex items-center gap-1.5 text-sm text-slate-500 mb-2">
                <CalendarIcon className="w-3.5 h-3.5 text-transparent flex-shrink-0" />
                <span><span className="text-slate-400 text-xs mr-1">Ende</span>{fmt(e.end_date)}</span>
              </p>
            )}
            {e.ticket_price && (
              <p className="flex items-center gap-1.5 text-sm font-bold text-sand-600 mb-3">
                <NavTicketIcon className="w-3.5 h-3.5 text-sand-400 flex-shrink-0" />
                {parseFloat(e.ticket_price).toFixed(2)} €
              </p>
            )}
            <Link to={`/events/${e.id}`} className="mt-auto no-underline btn-primary btn-sm">Details →</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
